/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3ProposalsProposalIdTalliesFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3ProposalsProposalIdTalliesFormat = ClosedEnum<
  typeof GetApiV3ProposalsProposalIdTalliesFormat
>;

export type GetApiV3ProposalsProposalIdTalliesRequest = {
  proposalId: number;
  format?: GetApiV3ProposalsProposalIdTalliesFormat | undefined;
  /**
   * Step value
   */
  step?: number | null | undefined;
};

/** @internal */
export const GetApiV3ProposalsProposalIdTalliesFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3ProposalsProposalIdTalliesFormat> = z
    .nativeEnum(GetApiV3ProposalsProposalIdTalliesFormat);

/** @internal */
export const GetApiV3ProposalsProposalIdTalliesFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3ProposalsProposalIdTalliesFormat> =
    GetApiV3ProposalsProposalIdTalliesFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ProposalsProposalIdTalliesFormat$ {
  /** @deprecated use `GetApiV3ProposalsProposalIdTalliesFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3ProposalsProposalIdTalliesFormat$inboundSchema;
  /** @deprecated use `GetApiV3ProposalsProposalIdTalliesFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ProposalsProposalIdTalliesFormat$outboundSchema;
}

/** @internal */
export const GetApiV3ProposalsProposalIdTalliesRequest$inboundSchema: z.ZodType<
  GetApiV3ProposalsProposalIdTalliesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  proposal_id: z.number().int(),
  format: GetApiV3ProposalsProposalIdTalliesFormat$inboundSchema.default(
    "json",
  ),
  step: z.nullable(z.number().int()).default(null),
}).transform((v) => {
  return remap$(v, {
    "proposal_id": "proposalId",
  });
});

/** @internal */
export type GetApiV3ProposalsProposalIdTalliesRequest$Outbound = {
  proposal_id: number;
  format: string;
  step: number | null;
};

/** @internal */
export const GetApiV3ProposalsProposalIdTalliesRequest$outboundSchema:
  z.ZodType<
    GetApiV3ProposalsProposalIdTalliesRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3ProposalsProposalIdTalliesRequest
  > = z.object({
    proposalId: z.number().int(),
    format: GetApiV3ProposalsProposalIdTalliesFormat$outboundSchema.default(
      "json",
    ),
    step: z.nullable(z.number().int()).default(null),
  }).transform((v) => {
    return remap$(v, {
      proposalId: "proposal_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ProposalsProposalIdTalliesRequest$ {
  /** @deprecated use `GetApiV3ProposalsProposalIdTalliesRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3ProposalsProposalIdTalliesRequest$inboundSchema;
  /** @deprecated use `GetApiV3ProposalsProposalIdTalliesRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ProposalsProposalIdTalliesRequest$outboundSchema;
  /** @deprecated use `GetApiV3ProposalsProposalIdTalliesRequest$Outbound` instead. */
  export type Outbound = GetApiV3ProposalsProposalIdTalliesRequest$Outbound;
}

export function getApiV3ProposalsProposalIdTalliesRequestToJSON(
  getApiV3ProposalsProposalIdTalliesRequest:
    GetApiV3ProposalsProposalIdTalliesRequest,
): string {
  return JSON.stringify(
    GetApiV3ProposalsProposalIdTalliesRequest$outboundSchema.parse(
      getApiV3ProposalsProposalIdTalliesRequest,
    ),
  );
}

export function getApiV3ProposalsProposalIdTalliesRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3ProposalsProposalIdTalliesRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3ProposalsProposalIdTalliesRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3ProposalsProposalIdTalliesRequest' from JSON`,
  );
}
